<div class="core-notifications-main">
  <!-- TODO: TEMPORAL here notification selection -->
  <!-- <h2> {{notifications.length}} NOtifications 
    <span (click)="addSuccess()">(SS)</span> 
    <span (click)="addFailed()">(FF)</span>
    <span (click)="addAction()">(AA)</span>
  </h2> -->
  <div  class="core-notification-item" *ngFor="let not of notifications">
    
    <ng-container [ngSwitch]="not.context" *ngIf="not.visible">
      <!-- NOTIFICATIONS BELOW -->
      <!-- event notification for vesion uppdate -->
      <core-notifications-helpers-event-version-status-update-success
        *ngSwitchCase="TYPES.EVENT_VERSION_STATUS_UPDATED_SUCCESS"
        [notification]="not"
      ></core-notifications-helpers-event-version-status-update-success>
      <!-- event notification for vesion uppdate -->
      <core-notifications-helpers-event-version-status-update-failed
        *ngSwitchCase="TYPES.EVENT_VERSION_STATUS_UPDATED_FAILED"
        [notification]="not"
      ></core-notifications-helpers-event-version-status-update-failed>
      <core-notifications-helpers-event-file-annotations-update-failed
        *ngSwitchCase="TYPES.EVENT_FILE_ANNOTATIONS_UPDATED_FAILED"
        [notification]="not"
      ></core-notifications-helpers-event-file-annotations-update-failed>

      <!-- ACTIONS BELOW-->
      <!-- action notification for start recording -->
      <core-notifications-helpers-action-record-start
        *ngSwitchCase="TYPES.ACTION_RECORD_START"
        [notification]="not"
      ></core-notifications-helpers-action-record-start>
      <!-- action notification for start compressing files -->
      <core-notifications-helpers-action-file-compression-start
        *ngSwitchCase="TYPES.EVENT_FILES_COMPRESSION_START"
        [notification]="not"
      ></core-notifications-helpers-action-file-compression-start>
      <!-- action notification for start download pdf with annotations -->
      <core-notifications-helpers-action-file-annotations-start
        *ngSwitchCase="TYPES.EVENT_FILE_ANNOTATIONS_START"
        [notification]="not"
      ></core-notifications-helpers-action-file-annotations-start>
      <!-- action notification for default failed event -->
      <core-notifications-helpers-event-default-failed
        *ngSwitchCase="TYPES.EVENT_FAILED"
        [notification]="not"
      ></core-notifications-helpers-event-default-failed>
      <div *ngSwitchDefault class="core-notification-item-default">
        <p>Not defined message at {{not.created | date:'dd MMM yyyy'}}</p>
      </div>
    </ng-container>
    
  </div>
</div>